import Vue from 'vue'
import Router from 'vue-router'
import CreateEvent from '@/components/CreateEvent'
import Event from '@/components/Event'
import Help from '@/components/Help'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'CreateEvent',
      component: CreateEvent
    },
    {
      path: '/event/:id',
      name: 'Event',
      component: Event,
      props: true
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '*',
      redirect: {
        name: 'CreateEvent'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js